export default __webpack_public_path__ + "static/media/copy_24px.5f7896b2.svg";